import React from 'react';
import styles from './DonationModal.module.css';
import { useLanguage } from '../Providers/LanguageContext';

interface DonationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

// Stripe donation link
const STRIPE_DONATION_LINK = 'https://buy.stripe.com/test_eVq28jbtraB52xK6w014402';

const DonationModal: React.FC<DonationModalProps> = ({ isOpen, onClose }) => {
  const { t } = useLanguage();

  if (!isOpen) return null;

  const handleDonate = () => {
    // Redirect to Stripe donation page
    window.location.href = STRIPE_DONATION_LINK;
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>×</button>

        <div className={styles.header}>
          <h2 className={styles.title}>{t('donation.title')}</h2>
        </div>

        <div className={styles.story}>
          <p>{t('donation.story1')}</p>
          <p>{t('donation.story2')}</p>
        </div>

        <button
          className={styles.donateButton}
          onClick={handleDonate}
        >
          {t('donation.donateButton')}
        </button>

        <p className={styles.disclaimer}>{t('donation.disclaimer')}</p>
      </div>
    </div>
  );
};

export default DonationModal;
